export enum Fonts {
  DEFAULT = `Roboto, sans-serif`,
  TITLE = `Ubuntu, sans-serif`,
}

export enum HeaderColors {
  BACKGROUND = "rgba(210, 95, 95, 0.5)",
  SHADOW = `rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px`,
}

export enum PageColors {
  COLOR = `rgba(0, 0, 0, 0.5)`,
  BACKGROUND = "rgba(255, 255, 255, 0.8)",
  SHADOW = `rgba(0, 0, 0, 0.25) 0px 25px 50px -12px`,
}

export enum ToggleBtnColors {
  BACKGROUND = "rgba(210, 95, 95, 0.5)",
  HOVER = "rgba(210, 95, 95, 0.5)",
  BORDER = `#8E8E8E`,
}

export enum ButtonColors {
  COLOR = `rgba(0, 0, 0, 0.5)`,
  SHADOW = `rgba(0, 0, 0, 0.16) 0px 1px 4px`,
}

export enum PresetListBtnColors {
  HOVER = "rgba(25, 118, 210, 0.04)",
  COLOR = `rgba(0, 0, 0, 0.5)`,
  SHADOW = `rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px`,
}

export enum PresetImageColors {
  SHADOW = `rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset`,
}

export enum TagColors {
  COLOR = `rgba(0, 0, 0, 0.5)`,
  BACKGROUND = "#ffe4c4",
}

export enum CommentColors {
  COLOR = `rgba(0, 0, 0, 0.75)`,
}
